export default __webpack_public_path__ + "static/media/LogoName.1459cc23.svg";